import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useLanguage, localizedPath } from "@/lib/i18n";
import { Logo } from "@/components/Logo";

export default function Footer() {
  const { t, lang } = useLanguage();
  return (
    <footer className="border-t border-black/10 bg-coal" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-6 py-12 md:px-12 md:py-16 lg:px-16">
        <div className="grid grid-cols-12 gap-x-6 gap-y-10 md:gap-x-10">
          <div className="col-span-12 md:col-span-7">
            <Link to={localizedPath("/", lang)} aria-label={t("Startseite")} data-testid="footer-logo-link" className="inline-block text-bone transition-colors duration-300 hover:text-ember-deep">
              <Logo width={120} />
            </Link>
          </div>
          <div className="col-span-12 md:col-span-5">
            <p className="mb-5 font-mono text-[10px] uppercase tracking-[0.3em] text-smoke">{t("Kontakt")}</p>
            <ul className="space-y-3 text-sm">
              <li>
                <a data-testid="footer-link-email" href="mailto:mail@wimjansen.de" className="inline-flex items-center gap-1 text-bone/80 transition-colors hover:text-ember-deep">
                  mail@wimjansen.de <ArrowUpRight size={13} />
                </a>
              </li>
              <li className="text-bone/80">+49 170 810 55 68</li>
              <li>
                <a
                  data-testid="footer-link-instagram"
                  href="https://www.instagram.com/wimjansen.de/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-1 text-bone/80 transition-colors hover:text-ember-deep"
                >
                  Instagram <ArrowUpRight size={13} />
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-black/10 pt-8 md:flex-row md:items-center">
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-smoke">
            {t("© 2026 Wim Jansen Delgado · Alle Rechte vorbehalten")}
          </p>
          <div className="flex gap-6">
            <Link
              to={localizedPath("/impressum", lang)}
              data-testid="footer-link-impressum"
              className="font-mono text-[10px] uppercase tracking-[0.3em] text-smoke transition-colors hover:text-ember-deep"
            >
              {t("Impressum")}
            </Link>
            <Link
              to={localizedPath("/datenschutz", lang)}
              data-testid="footer-link-datenschutz"
              className="font-mono text-[10px] uppercase tracking-[0.3em] text-smoke transition-colors hover:text-ember-deep"
            >
              {t("Datenschutz")}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
